$shm_hitalama_map_widget_tools_link_pick $mol_pick
	Input $mol_view
